import React from 'react';
import './index.css'
import {  WingBlank, Icon, InputItem, } from 'antd-mobile';
import TagItem from '../tagItem' 
class Sidebar extends React.Component{
  constructor(props){
    super(props);
    this.state={
      inputValue:'',
      cateId:[]
    }
  }
  changeValue(value){
    this.setState({
      inputValue:value
    })
   
  }
  changeCateId(cateId){
    this.setState({
      cateId
    })
  }
  cancelClick(){
    this.child.clearSelect()
    this.props.sideClick('','');
    this.setState({
      inputValue:'',
      cateId:[]
    })
  }
  confirmClick(){
    this.props.sideClick(this.state.inputValue,this.state.cateId);
    // this.setState({
    //   inputValue:'',
    // })
  }
    onRef = (ref) => {
        this.child = ref
    }
  render(){
    const {categoryList} = this.props;
    return(
      <div className="sidebar">
        <div className="sidebar-top">
            <div className="input-wrapper">
              <InputItem 
                clear
                placeholder="输入关键词搜索"
                value={this.state.inputValue}
                onChange={(e)=>{this.changeValue(e)}}
              >
              <Icon type="search" size='xs' className="icon_search"/>
              </InputItem>
            </div>
        </div>
        <div className="sidebar-content">
          <WingBlank>
             <TagItem title="课程类型" 
               data={categoryList}
               cate={this.state.cateId}
                      onRef={this.onRef}
               changeCateId={(cateid)=>{this.changeCateId(cateid)}}/> 
          </WingBlank>
        </div>
        <div className="sidebar-bottom">
          <div className="cancelBtn" onClick={()=>{this.cancelClick()}}>取消</div>
          <div className="confirmBtn" onClick={()=>{this.confirmClick()}}>确定</div>
        </div>
      </div>
      )
  }
}
export default Sidebar;